import { InlineText2 } from '@cian/ui-kit/typography';
import { Faq16 } from '@cian/ui-kit/icons';

import * as React from 'react';

import { Tooltip } from '../../../../../../../common/components/tooltip/Tooltip';

import { ICoworkingWorkplacesCountSubtitleViewProps } from './types';

const styles = require('./CoworkingWorkplacesCountSubtitleView.css');

export const CoworkingWorkplacesCountSubtitleView: React.FC<ICoworkingWorkplacesCountSubtitleViewProps> = props => {
  const { title, tooltipTitle } = props;

  return (
    <div className={styles['container']}>
      <span className={styles['title']}>
        <InlineText2>{title}</InlineText2>
      </span>
      {tooltipTitle && (
        <Tooltip
          icon={(
            <span className={styles['info-icon']}>
              <Faq16 color="primary_10" />
            </span>
          )}
          containerClassName={styles['tooltip-container']}
          iconSize={16}
          iconColor=""
        >
          <InlineText2 color="white_100">{tooltipTitle}</InlineText2>
        </Tooltip>
      )}
    </div>
  );
};

CoworkingWorkplacesCountSubtitleView.displayName = 'CoworkingWorkplacesCountSubtitleView';
